import styled from 'styled-components';
// ============================================
// INVENTORY CONTAINER - Matches Financial Hub
// ============================================
export const InventoryContainer = styled.div `
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
`;
// ============================================
// HEADER BAR - Clean, simple
// ============================================
export const InventoryHeader = styled.header `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: var(--bg-tertiary);
  border-bottom: 2px solid var(--accent-gold);
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;
export const InventoryTitleGroup = styled.div `
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;
export const InventoryIcon = styled.div `
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(184, 134, 11, 0.1);
  border: 1px solid rgba(184, 134, 11, 0.3);
  border-radius: 8px;
  color: var(--accent-gold);
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;
export const TitleText = styled.div `
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
export const InventoryTitle = styled.h2 `
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  color: var(--text-primary) !important;
  margin: 0 !important;

  span {
    color: var(--accent-gold);
  }

  @media (max-width: 768px) {
    font-size: 1rem !important;
  }
`;
export const InventorySubtitle = styled.p `
  font-size: 0.75rem;
  color: var(--text-tertiary);
  margin: 0;
`;
// ============================================
// INLINE STATS - Clean pills
// ============================================
export const InventoryStats = styled.div `
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    order: 3;
    width: 100%;
    justify-content: space-between;
  }
`;
export const StatPill = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  min-width: 70px;
  transition: all 0.2s;

  &:hover {
    border-color: var(--accent-gold);
    background: rgba(184, 134, 11, 0.05);
  }

  @media (max-width: 768px) {
    flex: 1;
    min-width: unset;
    padding: 0.5rem 0.75rem;
  }
`;
export const StatPillValue = styled.span `
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.2;
  font-family: 'JetBrains Mono', monospace;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;
export const StatPillLabel = styled.span `
  font-size: 0.625rem;
  font-weight: 600;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 2px;
`;
// ============================================
// VIEW TOGGLE
// ============================================
export const ViewToggle = styled.div `
  display: flex;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--bg-primary);
  overflow: hidden;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const ViewBtn = styled.button `
  padding: 0.5rem 0.75rem;
  background: ${props => props.$active ? 'var(--accent-gold)' : 'transparent'};
  border: none;
  color: ${props => props.$active ? 'white' : 'var(--text-tertiary)'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;

  &:first-child {
    border-right: 1px solid var(--border-color);
  }

  &:hover {
    color: ${props => props.$active ? 'white' : 'var(--accent-gold)'};
    background: ${props => props.$active ? 'var(--accent-gold)' : 'rgba(184, 134, 11, 0.1)'};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
// ============================================
// TABLE WRAPPER - Matches Financial Hub
// ============================================
export const InventoryTableWrapper = styled.div `
  overflow-x: auto;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
`;
// ============================================
// TABLE STYLES - Matches Financial Hub SharedComponents
// ============================================
export const InventoryTable = styled.table `
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;

  th {
    text-align: left;
    padding: 1rem;
    background: var(--bg-tertiary);
    border-bottom: 1px solid var(--border-color);
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--text-primary);
    white-space: nowrap;

    @media (max-width: 768px) {
      padding: 0.75rem;
      font-size: 0.8rem;
    }
  }

  td {
    padding: 1rem;
    border-bottom: 1px solid var(--border-color);
    font-size: 0.875rem;
    color: var(--text-primary);
    vertical-align: middle;

    @media (max-width: 768px) {
      padding: 0.75rem;
      font-size: 0.8rem;
    }
  }

  tbody tr {
    transition: background 0.15s;

    &:hover {
      background: var(--bg-tertiary);
    }

    &:last-child td {
      border-bottom: none;
    }
  }
`;
// ============================================
// CELL SPECIFIC STYLES
// ============================================
export const DiamondThumb = styled.img `
  width: 44px;
  height: 44px;
  object-fit: contain;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 4px;
`;
export const StockNumber = styled.span `
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-secondary);
`;
export const ShapeBadge = styled.span `
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-primary);
  white-space: nowrap;
`;
export const CaratValue = styled.span `
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
`;
export const GradeCell = styled.td `
  font-weight: 600;
  color: var(--text-primary) !important;
  font-size: 0.875rem;
`;
export const LabBadge = styled.span `
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: white;
  background: ${props => {
    switch (props.$lab?.toUpperCase()) {
        case 'GIA': return '#1B5E3B';
        case 'IGI': return '#8B6914';
        case 'AGS': return '#2C4A7C';
        case 'HRD': return '#6B2D5B';
        case 'EGL':
        case 'EGLUSA': return '#4A5568';
        default: return 'var(--text-tertiary)';
    }
}};
`;
export const CertNumber = styled.span `
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.75rem;
  color: var(--text-tertiary);
`;
export const PriceValue = styled.span `
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: var(--text-secondary);
`;
export const PriceTotal = styled.span `
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--accent-gold);
`;
// ============================================
// STATUS INDICATOR - Matches Financial Hub badges
// ============================================
export const StatusIndicator = styled.span `
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: ${props => {
    switch (props.$status?.toLowerCase()) {
        case 'available': return 'rgba(16, 185, 129, 0.1)';
        case 'reserved': return 'rgba(245, 158, 11, 0.1)';
        case 'sold': return 'rgba(239, 68, 68, 0.1)';
        case 'inquiry': return 'rgba(107, 114, 128, 0.1)';
        default: return 'rgba(107, 114, 128, 0.1)';
    }
}};
  color: ${props => {
    switch (props.$status?.toLowerCase()) {
        case 'available': return '#10b981';
        case 'reserved': return '#f59e0b';
        case 'sold': return '#ef4444';
        case 'inquiry': return '#6b7280';
        default: return '#6b7280';
    }
}};
`;
export const StatusDot = styled.span `
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`;
// ============================================
// ACTION BUTTONS - Matches Financial Hub style
// ============================================
export const ActionsCell = styled.td `
  display: flex;
  gap: 0.5rem;
`;
export const ActionBtn = styled.button `
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.375rem 0.625rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
  white-space: nowrap;

  ${props => props.$primary ? `
    background: rgba(184, 134, 11, 0.1);
    border-color: #B8860B;
    color: #B8860B;
    &:hover { background: rgba(184, 134, 11, 0.2); }
  ` : `
    background: var(--bg-tertiary);
    border-color: var(--border-color);
    color: var(--text-secondary);
    &:hover { background: var(--bg-secondary); color: var(--text-primary); }
  `}
`;
// ============================================
// FOOTER / PAGINATION
// ============================================
export const InventoryFooter = styled.footer `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: var(--bg-tertiary);
  border-top: 1px solid var(--border-color);
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;
export const Pagination = styled.div `
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
export const PaginationBtn = styled.button `
  padding: 0.5rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  gap: 0.375rem;

  &:hover:not(:disabled) {
    border-color: var(--accent-gold);
    color: var(--accent-gold);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
export const PaginationInfo = styled.span `
  font-size: 0.8rem;
  color: var(--text-tertiary);
  padding: 0 0.75rem;

  strong {
    color: var(--text-primary);
    font-weight: 600;
  }
`;
export const ShowingInfo = styled.div `
  font-size: 0.8rem;
  color: var(--text-tertiary);

  strong {
    color: var(--text-primary);
    font-weight: 600;
  }
`;
// ============================================
// FEATURED BADGE
// ============================================
export const FeaturedBadge = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--accent-gold);
  border-radius: 4px;
  color: white;
  font-size: 0.625rem;
  margin-left: 0.5rem;
  vertical-align: middle;
`;
